// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-position {
  right: -15px;
  top: -7px;
  position: absolute;
  width: 21px;
  height: 21px;
  color: var(--primary);
  pointer-events: none;
  line-height: 0;
}
[hidden] {
  display: none !important;
}
.hover-right {
  width: 12px !important;
  right: -8px !important;
}
.hover-right:hover {
  background-color: #106a9040;
  border-radius: 4px;
}
.hover-left {
  left: -8px !important;
  width: 12px !important;
}
.hover-left:hover {
  background-color: #106a9040;
  border-radius: 4px;
}
.hover-top {
  height: 12px !important;
  top: -8px !important;
}
.hover-top:hover {
  background-color: #106a9040;
  border-radius: 4px;
}
.hover-bottom {
  bottom: -8px !important;
  height: 12px !important;
}
.hover-bottom:hover {
  background-color: #106a9040;
  border-radius: 4px;
}
.hover-angle-bottom-right {
  width: 12px !important;
  height: 12px !important;
  right: -8px !important;
  bottom: -8px !important;
}
.hover-angle-bottom-right:hover {
  background-color: #106a9040;
  border-radius: 4px;
}
.hover-angle-bottom-left {
  width: 12px !important;
  height: 12px !important;
  left: -8px !important;
  bottom: -8px !important;
}
.hover-angle-bottom-left:hover {
  background-color: #106a9040;
  border-radius: 4px;
}
.hover-angle-top-left {
  width: 8px !important;
  height: 8px !important;
  left: -8px !important;
  top: -8px !important;
}
.hover-angle-top-left:hover {
  background-color: #106a9040;
  border-radius: 4px;
}
.hover-angle-top-right {
  width: 12px !important;
  height: 12px !important;
  right: -8px !important;
  top: -8px !important;
}
.hover-angle-top-right:hover {
  background-color: #106a9040;
  border-radius: 4px;
}
.popup-position {
  width: 100%;
  height: 100%;
  justify-content: space-between;
  border-radius: 3px;
  box-shadow: 0 3px 7px rgba(2, 34, 60, 0.16);
  position: absolute;
  content: "";
  display: flex;
  clear: both;
  flex-direction: column;
  background: #fff;
  border: 1px solid var(--icon-color);
  box-sizing: border-box;
}
.popup-position .title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 3px 3px 0 0;
  padding: 0;
}
.popup-position .title .title-name {
  font-weight: 500;
  padding: 0 5px;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: move;
}
.popup-position .title .title-name .object-select {
  padding: 0 16px 0 0;
}
.popup-position .title .title-name .layer-name {
  font-family: var(--ngw-head-font-family-list);
  font-weight: var(--ngw-text-font-weight);
}
.popup-position .title .icon-symbol {
  font-size: 16px;
  width: 24px;
  height: 24px;
  display: flex;
  justify-items: center;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
  margin: 0;
  cursor: pointer;
  color: var(--text-secondary);
  z-index: 1000;
  border-radius: 3px;
  border: none;
  background-color: none;
  box-sizing: border-box;
  margin-inline-start: 2px;
}
.popup-position .title .icon-symbol:hover {
  background-color: #00000010;
  color: var(--primary);
  border-radius: 3px;
  border: none;
}
.popup-position .title .icon-disabled {
  font-size: 16px;
  width: 24px;
  height: 24px;
  display: flex;
  justify-items: center;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
  margin: 0;
  cursor: pointer;
  color: var(--divider-color);
  box-sizing: border-box;
  pointer-events: none;
  margin-inline-start: 2px;
  border-radius: 3px;
}
.popup-position .select-feature-forbidden {
  padding: 2px 0 0 0;
  width: 100%;
  display: inline-flex;
  position: absolute;
  top: 24px;
}
.popup-position .select-feature {
  padding: 2px 0 0 0;
  width: 100%;
  display: inline-flex;
}
.popup-position .select-feature .edit-symbol {
  font-size: 16px;
  width: 24px;
  height: 24px;
  display: flex;
  padding: 0 0 0 0;
  margin: 0 2px 0 0;
  cursor: pointer;
  border: 1px solid var(--divider-color);
  border-radius: 4px;
  align-items: center;
  justify-content: center;
}
.popup-position .select-feature .edit-symbol:hover {
  background-color: #ffffff00;
  color: var(--primary);
}
.popup-position .ant-tabs .ant-tabs-content-holder {
  flex: auto;
  min-width: 0;
  min-height: 0;
  overflow: auto;
}
.popup-position .content {
  padding: 0;
  cursor: auto;
  top: 46px;
  display: flex;
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.popup-position .content .radio-block {
  display: flex;
  width: 30px;
  border-right: solid rgba(0, 0, 0, 0.04) 1px;
  flex-wrap: wrap;
  align-content: space-between;
  justify-content: center;
}
.popup-position .content .radio-block .radio-group {
  overflow: hidden;
}
.popup-position .content .radio-block .radio-group .radio-component {
  overflow: auto;
  height: auto;
}
.popup-position .content .radio-block .dropdown-block {
  padding: 2px;
}
.popup-position .content .radio-block .dropdown-block .drop-down-icon {
  font-size: 14px;
  width: 23px;
  height: 23px;
  display: flex;
  justify-items: center;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
  margin: 0;
  padding: 0;
  cursor: pointer;
  color: var(--text-base);
  z-index: 1000;
  border: solid var(--divider-color) 1px;
  border-radius: 4px;
}
.popup-position .content .radio-block .dropdown-block .drop-down-icon:hover {
  background-color: #ffffff00;
  color: var(--primary);
}
.popup-position .content .content-item {
  width: 100%;
  overflow: overlay;
  height: 100%;
}
.popup-position .content .content-item .content-move {
  height: 100%;
  width: 100%;
}
.popup-position .content .content-item .value-email {
  cursor: pointer;
  color: var(--primary);
}
.popup-position .content .content-item .ant-empty-image {
  height: 20px;
}
.popup-position .footer-popup {
  padding: 0;
  display: flex;
  width: 100%;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  cursor: move;
  justify-content: space-between;
  align-items: center;
  height: 24px;
}
.popup-position .footer-popup .footer-coordinate-component {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}
.popup-position .footer-popup .footer-coordinate-component .link-block {
  display: inline-flex;
  align-items: center;
}
.copy_to_clipboard {
  height: 20px;
  padding: 0;
  display: flex;
  align-items: center;
  margin: auto;
}
.copy_to_clipboard .ant-btn-icon {
  margin: auto;
}
.copy_to_clipboard button {
  width: 24px;
}
.copy_to_clipboard svg.icon {
  margin: 0;
  height: 18px;
  width: 18px;
}
.context-coord {
  display: flex;
  min-height: 24px;
  align-items: center;
}
.coordinate-value {
  padding: 0;
  cursor: pointer;
  border-radius: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: normal;
  min-height: 24px;
  display: flex;
  align-items: center;
}
.coordinate-value .icon-location {
  padding: 0 5px;
}
.coordinate-value .coords {
  padding: 0 0;
}
.icon-position-popup {
  left: -5px;
  top: -5px;
  position: absolute;
  pointer-events: none;
  line-height: 0;
  color: white;
  font-size: 9px;
}
.context-position {
  overflow: auto;
  padding: 0;
  min-width: 100px;
  background: #ffffff;
  border-radius: 3px;
  border: solid var(--divider-color) 1px;
  box-sizing: border-box;
  user-select: text;
  pointer-events: auto;
  box-shadow: 0 3px 7px rgba(2, 34, 60, 0.16);
  z-index: 1;
}
.context-position .context-coords {
  font-weight: 500;
  display: flex;
  padding: 0 5px;
  justify-content: center;
  align-items: center;
  border-bottom: solid var(--divider-color) 0.005em;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  cursor: pointer;
}
.context-position .context-item {
  cursor: pointer;
  padding: 5px;
  user-select: none;
  min-height: 24px;
  display: flex;
  align-items: center;
}
.context-position .context-item:hover {
  background-color: #F5F5F5;
  padding: 5px;
  border-radius: 3px;
}
.label-select {
  width: 100%;
  display: flex;
  align-items: center;
}
.label-select .label-feature {
  max-width: 50%;
  flex: auto;
  overflow: hidden;
  white-space: nowrap;
  padding: 0 3px 0 0;
  text-overflow: ellipsis;
}
.label-select .label-style {
  max-width: 50%;
  flex: auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: right;
}
.error-component {
  display: flex;
  justify-content: center;
}
.ant-tag {
  margin-inline-end: 0;
  padding-inline: 4px;
}
.ant-tag-checkable-checked {
  background-color: #ffffff00;
  color: var(--primary);
}
.link-button {
  font-size: 16px;
  width: 24px;
  height: 24px;
  display: flex;
  justify-items: center;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
  margin: 0;
  cursor: pointer;
  color: var(--text-secondary);
  z-index: 1000;
  border: none;
}
.link-button:hover {
  background-color: #00000010;
  color: var(--primary);
  border-radius: 3px;
  border: none;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/webmap/nodepkg/identify-module/IdentifyModule.less"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,oBAAA;EACA,cAAA;AACJ;AAEA;EACI,wBAAA;AAAJ;AAGA;EACI,sBAAA;EACA,sBAAA;AADJ;AAGI;EACI,2BAAA;EACA,kBAAA;AADR;AAKA;EACI,qBAAA;EACA,sBAAA;AAHJ;AAKI;EACI,2BAAA;EACA,kBAAA;AAHR;AAOA;EACI,uBAAA;EACA,oBAAA;AALJ;AAOI;EACI,2BAAA;EACA,kBAAA;AALR;AASA;EACI,uBAAA;EACA,uBAAA;AAPJ;AASI;EACI,2BAAA;EACA,kBAAA;AAPR;AAWA;EACI,sBAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;AATJ;AAWI;EACI,2BAAA;EACA,kBAAA;AATR;AAaA;EACI,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,uBAAA;AAXJ;AAaI;EACI,2BAAA;EACA,kBAAA;AAXR;AAeA;EACI,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,oBAAA;AAbJ;AAeI;EACI,2BAAA;EACA,kBAAA;AAbR;AAiBA;EACI,sBAAA;EACA,uBAAA;EACA,sBAAA;EACA,oBAAA;AAfJ;AAiBI;EACI,2BAAA;EACA,kBAAA;AAfR;AAmBA;EACI,WAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,2CAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,mCAAA;EACA,sBAAA;AAjBJ;AAIA;EAgBQ,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,0BAAA;EACA,UAAA;AAjBR;AAHA;EAuBY,gBAAA;EACA,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;AAjBZ;AAZA;EAgCgB,mBAAA;AAjBhB;AAfA;EAoCgB,6CAAA;EACA,wCAAA;AAlBhB;AAnBA;EA0CY,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,SAAA;EACA,eAAA;EACA,4BAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,wBAAA;AApBZ;AAsBY;EACI,2BAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;AApBhB;AA5CA;EAqEY,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,SAAA;EACA,eAAA;EACA,2BAAA;EAGA,sBAAA;EACA,oBAAA;EACA,wBAAA;EACA,kBAAA;AAxBZ;AA7DA;EA0FQ,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,SAAA;AA1BR;AApEA;EAkGQ,kBAAA;EACA,WAAA;EACA,oBAAA;AA3BR;AAzEA;EAuGY,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,sCAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;AA3BZ;AA6BY;EACI,2BAAA;EACA,qBAAA;AA3BhB;AA1FA;EA2HQ,UAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;AA9BR;AAhGA;EAkIQ,UAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AA/BR;AAzGA;EA2IY,aAAA;EACA,WAAA;EACA,2CAAA;EACA,eAAA;EACA,4BAAA;EACA,uBAAA;AA/BZ;AAjHA;EAmJgB,gBAAA;AA/BhB;AApHA;EAsJoB,cAAA;EACA,YAAA;AA/BpB;AAxHA;EA4JgB,YAAA;AAjChB;AA3HA;EA+JoB,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,uBAAA;EACA,aAAA;EACA,sCAAA;EACA,kBAAA;AAjCpB;AAmCoB;EACI,2BAAA;EACA,qBAAA;AAjCxB;AAhJA;EAwLY,WAAA;EACA,iBAAA;EACA,YAAA;AArCZ;AArJA;EA6LgB,YAAA;EACA,WAAA;AArChB;AAzJA;EAkMgB,eAAA;EACA,qBAAA;AAtChB;AA7JA;EAuMgB,YAAA;AAvChB;AAhKA;EA6MQ,UAAA;EACA,aAAA;EACA,WAAA;EACA,8BAAA;EACA,+BAAA;EACA,YAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;AA1CR;AA3KA;EAwNY,aAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;AA1CZ;AAjLA;EA8NgB,oBAAA;EACA,mBAAA;AA1ChB;AAgDA;EACI,YAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AA9CJ;AAyCA;EAQQ,YAAA;AA9CR;AAsCA;EAYQ,WAAA;AA/CR;AAmCA;EAgBQ,SAAA;EACA,YAAA;EACA,WAAA;AAhDR;AAoDA;EACI,aAAA;EACA,gBAAA;EACA,mBAAA;AAlDJ;AAqDA;EACI,UAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAnDJ;AAyCA;EAaQ,cAAA;AAnDR;AAsCA;EAiBQ,YAAA;AApDR;AAyDA;EACI,UAAA;EACA,SAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,YAAA;EACA,cAAA;AAvDJ;AA0DA;EACI,cAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sCAAA;EACA,sBAAA;EACA,iBAAA;EACA,oBAAA;EACA,2CAAA;EACA,UAAA;AAxDJ;AA6CA;EAcQ,gBAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,iDAAA;EACA,2BAAA;EACA,4BAAA;EACA,eAAA;AAxDR;AAkCA;EA0BQ,eAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAzDR;AA2DQ;EACI,yBAAA;EACA,YAAA;EACA,kBAAA;AAzDZ;AA8DA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;AA5DJ;AAyDA;EAMQ,cAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;AA5DR;AAiDA;EAeQ,cAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AA7DR;AAiEA;EACI,aAAA;EACA,uBAAA;AA/DJ;AAkEA;EACI,oBAAA;EACA,mBAAA;AAhEJ;AAmEA;EACI,2BAAA;EACA,qBAAA;AAjEJ;AAoEA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,SAAA;EACA,eAAA;EACA,4BAAA;EACA,aAAA;EACA,YAAA;AAlEJ;AAoEI;EACI,2BAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;AAlER","sourcesContent":[".icon-position {\n    right: -15px;\n    top: -7px;\n    position: absolute;\n    width: 21px;\n    height: 21px;\n    color: var(--primary);\n    pointer-events: none;\n    line-height: 0;\n}\n\n[hidden] {\n    display: none !important;\n}\n\n.hover-right {\n    width: 12px !important;\n    right: -8px !important;\n\n    &:hover {\n        background-color: #106a9040;\n        border-radius: 4px;\n    }\n}\n\n.hover-left {\n    left: -8px !important;\n    width: 12px !important;\n\n    &:hover {\n        background-color: #106a9040;\n        border-radius: 4px;\n    }\n}\n\n.hover-top {\n    height: 12px !important;\n    top: -8px !important;\n\n    &:hover {\n        background-color: #106a9040;\n        border-radius: 4px;\n    }\n}\n\n.hover-bottom {\n    bottom: -8px !important;\n    height: 12px !important;\n\n    &:hover {\n        background-color: #106a9040;\n        border-radius: 4px;\n    }\n}\n\n.hover-angle-bottom-right {\n    width: 12px !important;\n    height: 12px !important;\n    right: -8px !important;\n    bottom: -8px !important;\n\n    &:hover {\n        background-color: #106a9040;\n        border-radius: 4px;\n    }\n}\n\n.hover-angle-bottom-left {\n    width: 12px !important;\n    height: 12px !important;\n    left: -8px !important;\n    bottom: -8px !important;\n\n    &:hover {\n        background-color: #106a9040;\n        border-radius: 4px;\n    }\n}\n\n.hover-angle-top-left {\n    width: 8px !important;\n    height: 8px !important;\n    left: -8px !important;\n    top: -8px !important;\n\n    &:hover {\n        background-color: #106a9040;\n        border-radius: 4px;\n    }\n}\n\n.hover-angle-top-right {\n    width: 12px !important;\n    height: 12px !important;\n    right: -8px !important;\n    top: -8px !important;\n\n    &:hover {\n        background-color: #106a9040;\n        border-radius: 4px;\n    }\n}\n\n.popup-position {\n    width: 100%;\n    height: 100%;\n    justify-content: space-between;\n    border-radius: 3px;\n    box-shadow: 0 3px 7px rgba(2, 34, 60, 0.16);\n    position: absolute;\n    content: \"\";\n    display: flex;\n    clear: both;\n    flex-direction: column;\n    background: #fff;\n    border: 1px solid var(--icon-color);\n    box-sizing: border-box;\n\n    .title {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        border-radius: 3px 3px 0 0;\n        padding: 0;\n\n        .title-name {\n            font-weight: 500;\n            padding: 0 5px;\n            width: 100%;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            cursor: move;\n\n            .object-select {\n                padding: 0 16px 0 0;\n            }\n\n            .layer-name {\n                font-family: var(--ngw-head-font-family-list);\n                font-weight: var(--ngw-text-font-weight);\n            }\n        }\n\n        .icon-symbol {\n            font-size: 16px;\n            width: 24px;\n            height: 24px;\n            display: flex;\n            justify-items: center;\n            justify-content: center;\n            align-items: center;\n            flex: 0 0 auto;\n            margin: 0;\n            cursor: pointer;\n            color: var(--text-secondary);\n            z-index: 1000;\n            border-radius: 3px;\n            border: none;\n            background-color: none;\n            box-sizing: border-box;\n            margin-inline-start: 2px;\n\n            &:hover {\n                background-color: #00000010;\n                color: var(--primary);\n                border-radius: 3px;\n                border: none;\n            }\n        }\n\n        .icon-disabled {\n            font-size: 16px;\n            width: 24px;\n            height: 24px;\n            display: flex;\n            justify-items: center;\n            justify-content: center;\n            align-items: center;\n            flex: 0 0 auto;\n            margin: 0;\n            cursor: pointer;\n            color: var(--divider-color);\n            // border: solid var(--divider-color) 1px;\n            // background: #8d8d8d36;\n            box-sizing: border-box;\n            pointer-events: none;\n            margin-inline-start: 2px;\n            border-radius: 3px;\n        }\n    }\n\n    .select-feature-forbidden {\n        padding: 2px 0 0 0;\n        width: 100%;\n        display: inline-flex;\n        position: absolute;\n        top: 24px;\n    }\n\n    .select-feature {\n        padding: 2px 0 0 0;\n        width: 100%;\n        display: inline-flex;\n\n        .edit-symbol {\n            font-size: 16px;\n            width: 24px;\n            height: 24px;\n            display: flex;\n            padding: 0 0 0 0;\n            margin: 0 2px 0 0;\n            cursor: pointer;\n            border: 1px solid var(--divider-color);\n            border-radius: 4px;\n            align-items: center;\n            justify-content: center;\n\n            &:hover {\n                background-color: #ffffff00;\n                color: var(--primary);\n            }\n        }\n    }\n\n    .ant-tabs .ant-tabs-content-holder {\n        flex: auto;\n        min-width: 0;\n        min-height: 0;\n        overflow: auto;\n    }\n\n    .content {\n        padding: 0;\n        cursor: auto;\n        top: 46px;\n        display: flex;\n        overflow: hidden;\n        width: 100%;\n        height: 100%;\n\n        .radio-block {\n            display: flex;\n            width: 30px;\n            border-right: solid rgba(0, 0, 0, 0.04) 1px;\n            flex-wrap: wrap;\n            align-content: space-between;\n            justify-content: center;\n\n            .radio-group {\n                overflow: hidden;\n\n                .radio-component {\n                    overflow: auto;\n                    height: auto;\n                }\n            }\n\n            .dropdown-block {\n                padding: 2px;\n\n                .drop-down-icon {\n                    font-size: 14px;\n                    width: 23px;\n                    height: 23px;\n                    display: flex;\n                    justify-items: center;\n                    justify-content: center;\n                    align-items: center;\n                    flex: 0 0 auto;\n                    margin: 0;\n                    padding: 0;\n                    cursor: pointer;\n                    color: var(--text-base);\n                    z-index: 1000;\n                    border: solid var(--divider-color) 1px;\n                    border-radius: 4px;\n\n                    &:hover {\n                        background-color: #ffffff00;\n                        color: var(--primary);\n                    }\n                }\n            }\n        }\n\n        .content-item {\n            width: 100%;\n            overflow: overlay;\n            height: 100%;\n\n            .content-move {\n                height: 100%;\n                width: 100%;\n            }\n\n            .value-email {\n                cursor: pointer;\n                color: var(--primary);\n            }\n\n            .ant-empty-image {\n                height: 20px;\n            }\n        }\n    }\n\n    .footer-popup {\n        padding: 0;\n        display: flex;\n        width: 100%;\n        border-bottom-left-radius: 3px;\n        border-bottom-right-radius: 3px;\n        cursor: move;\n        justify-content: space-between;\n        align-items: center;\n        height: 24px;\n\n        .footer-coordinate-component {\n            display: flex;\n            align-items: center;\n            width: 100%;\n            justify-content: space-between;\n\n            .link-block {\n                display: inline-flex;\n                align-items: center;\n            }\n        }\n    }\n}\n\n.copy_to_clipboard {\n    height: 20px;\n    padding: 0;\n    display: flex;\n    align-items: center;\n    margin: auto;\n\n    .ant-btn-icon {\n        margin: auto;\n    }\n\n    button {\n        width: 24px;\n    }\n\n    svg.icon {\n        margin: 0;\n        height: 18px;\n        width: 18px;\n    }\n}\n\n.context-coord {\n    display: flex;\n    min-height: 24px;\n    align-items: center;\n}\n\n.coordinate-value {\n    padding: 0;\n    cursor: pointer;\n    border-radius: 3px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    line-height: normal;\n    min-height: 24px;\n    display: flex;\n    align-items: center;\n\n    .icon-location {\n        padding: 0 5px;\n    }\n\n    .coords {\n        padding: 0 0;\n    }\n}\n\n\n.icon-position-popup {\n    left: -5px;\n    top: -5px;\n    position: absolute;\n    pointer-events: none;\n    line-height: 0;\n    color: white;\n    font-size: 9px;\n}\n\n.context-position {\n    overflow: auto;\n    padding: 0;\n    min-width: 100px;\n    background: #ffffff;\n    border-radius: 3px;\n    border: solid var(--divider-color) 1px;\n    box-sizing: border-box;\n    user-select: text;\n    pointer-events: auto;\n    box-shadow: 0 3px 7px rgba(2, 34, 60, 0.16);\n    z-index: 1;\n\n    .context-coords {\n        font-weight: 500;\n        display: flex;\n        padding: 0 5px;\n        justify-content: center;\n        align-items: center;\n        border-bottom: solid var(--divider-color) 0.005em;\n        border-top-left-radius: 3px;\n        border-top-right-radius: 3px;\n        cursor: pointer;\n    }\n\n    .context-item {\n        cursor: pointer;\n        padding: 5px;\n        user-select: none;\n        min-height: 24px;\n        display: flex;\n        align-items: center;\n\n        &:hover {\n            background-color: #F5F5F5;\n            padding: 5px;\n            border-radius: 3px;\n        }\n    }\n}\n\n.label-select {\n    width: 100%;\n    display: flex;\n    align-items: center;\n\n    .label-feature {\n        max-width: 50%;\n        flex: auto;\n        overflow: hidden;\n        white-space: nowrap;\n        padding: 0 3px 0 0;\n        text-overflow: ellipsis;\n    }\n\n    .label-style {\n        max-width: 50%;\n        flex: auto;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        text-align: right;\n    }\n}\n\n.error-component {\n    display: flex;\n    justify-content: center;\n}\n\n.ant-tag {\n    margin-inline-end: 0;\n    padding-inline: 4px;\n}\n\n.ant-tag-checkable-checked {\n    background-color: #ffffff00;\n    color: var(--primary);\n}\n\n.link-button {\n    font-size: 16px;\n    width: 24px;\n    height: 24px;\n    display: flex;\n    justify-items: center;\n    justify-content: center;\n    align-items: center;\n    flex: 0 0 auto;\n    margin: 0;\n    cursor: pointer;\n    color: var(--text-secondary);\n    z-index: 1000;\n    border: none;\n\n    &:hover {\n        background-color: #00000010;\n        color: var(--primary);\n        border-radius: 3px;\n        border: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
